if (!customElements.get('tmg-buy-qty')) {
  customElements.define(
    'tmg-buy-qty',
    class TmgBuyQty extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('.tmg-buy-qty__select');
        this.value = this.querySelector('.tmg-buy-qty__value');
        this.button = this.querySelector('.tmg-buy-qty__submit');
        this.label = this.querySelector('.tmg-buy-qty__label');
        this.idInput = this.querySelector('input[name="id"]');

        this.onQuantityChange = () => (this.value.textContent = this.select.value);
        this.select.addEventListener('change', this.onQuantityChange);
        this.onQuantityChange();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onQuantityChange);
        this.unsubscribe?.();
      }

      // The theme re-renders the section for the new variant; copy this block's
      // fresh server-rendered state (variant id, quantity cap, availability, label).
      // This also re-applies our label after product-info resets the first
      // <product-form>'s button text to its own "Add to cart" string.
      onVariantChange({ data: { sectionId, html } }) {
        const productInfo = this.closest('product-info');
        if (productInfo?.sectionId && sectionId !== productInfo.sectionId) return;

        const fresh = html.querySelector(`tmg-buy-qty[data-block-id="${this.dataset.blockId}"]`);
        if (!fresh) return;

        const freshId = fresh.querySelector('input[name="id"]');
        this.idInput.value = freshId.value;
        this.idInput.disabled = false;

        const freshSelect = fresh.querySelector('.tmg-buy-qty__select');
        const current = parseInt(this.select.value, 10) || 1;
        this.select.innerHTML = freshSelect.innerHTML;
        this.select.value = String(Math.min(current, this.select.options.length));
        this.select.disabled = freshSelect.disabled;
        this.onQuantityChange();

        const freshButton = fresh.querySelector('.tmg-buy-qty__submit');
        this.button.disabled = freshButton.disabled;
        this.label.textContent = fresh.querySelector('.tmg-buy-qty__label').textContent;
      }
    }
  );
}
